import { createReducer, on } from "@ngrx/store";
import { Agent } from "../../models/agent-fields";
import { AgentActions } from "../actions/agent.actions";
import { initialState } from "../states/agent.state";
export const agentReducer = createReducer(
  initialState,

  // Load Agents
  on(AgentActions.loadAgent, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(AgentActions.loadAgentSuccess, (state, { agentList }) => ({
    ...state,
    loading: false,
    agentList,
  })),

  on(AgentActions.loadAgentFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Create Agent
  on(AgentActions.createAgent, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(AgentActions.createAgentSuccess, (state, { agent }) => ({
    ...state,
    agentList: [...state.agentList, agent],
    loading: false,
    error: null,
  })),

  on(AgentActions.createAgentFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  //   update agent
  on(AgentActions.updateAgent, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(AgentActions.updateAgentSuccess, (state, { agent }) => ({
    ...state,
    loading: false,
    agentList: state.agentList.map((agentOld: Agent) =>
      agentOld.id === agent?.data?.id ? agent.data : agentOld
    ),
    error: null,
  })),

  on(AgentActions.updateAgentFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

   //   reclaim agent
   on(AgentActions.reclaimAgent, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(AgentActions.reclaimAgentSuccess, (state, { agents }) => ({
    ...state,
    loading: false,
    // agentList: state.agentList.map((agentOld: Agent) => {
    //   const updatedAgent = agents.find((agentNew:any) => agentNew.data.id === agentOld.id);
    //   return updatedAgent ? updatedAgent.data : agentOld;
    // }),
    error: null,
  })),
  

  on(AgentActions.reclaimAgentFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  //   delete agent
  on(AgentActions.deleteAgent, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(AgentActions.deleteAgentSuccess, (state, { agentIdList }) => ({
    ...state,
    loading: false,
    agentList: state.agentList.filter((agent) => !agentIdList.includes(agent.id)),
    error: null,
  })), 
  on(AgentActions.deleteAgentFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
